import { initSentry } from "@/lib/sentry";
import { initOneSignal } from "@/lib/onesignal";
import type { ConsentPreferences } from "@/lib/analytics";

// Non-essential SDKs start ONLY once the matching cookie consent is granted
// (#171): Sentry (error tracking) on analytics consent, OneSignal (push) on
// marketing consent. Both init functions are idempotent, so this is safe to call
// from the consent-boot path and again whenever the user updates preferences.
//
// Note: granting takes effect immediately; revoking can't fully unload an
// already-running SDK mid-session — it's honored on the next page load. The
// compliance win is that nothing loads BEFORE consent. (GA itself updates live
// via updateConsent.)
export function applyConsentToSdks(prefs: ConsentPreferences) {
  if (prefs.analytics) initSentry();
  if (prefs.marketing) initOneSignal(import.meta.env.VITE_ONESIGNAL_APP_ID as string | undefined);
}
